import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CountryProvider } from './contexts/CountryContext';
import { ModalProvider } from './contexts/ModalContext';
import { ScrollToTop } from './components/ScrollToTop';
import { PageTransition } from './components/PageTransition';
import { GlobalModals } from './components/GlobalModals';
import { Home } from './pages/Home';
import { HomeCare } from './pages/HomeCare';
import { CompanionCare } from './pages/CompanionCare';
import { PostHospitalRespite } from './pages/PostHospitalRespite';
import { Childcare } from './pages/Childcare';
import { EquipmentRentals } from './pages/EquipmentRentals';
import { Facilities } from './pages/Facilities';
import { Careers } from './pages/Careers';
import { BookNow } from './pages/BookNow';
import { WhyUs } from './pages/WhyUs';
import { Blog } from './pages/Blog';
import { FAQ } from './pages/FAQ';
import { Contact } from './pages/Contact';
import { SearchResults } from './pages/SearchResults';
import { TrustAndSafety } from './pages/TrustAndSafety';
import { CorporateCare } from './pages/CorporateCare';
import { PetCare } from './pages/PetCare';
import { Housekeeping } from './pages/Housekeeping';
import { CheckIns } from './pages/CheckIns';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
import { PostJob } from './pages/PostJob';

// US Pages
import { NanniesUS } from './pages/us/Nannies';
import { TravelNursesUS } from './pages/us/TravelNurses';
import { EquipmentRentalsUS } from './pages/us/EquipmentRentalsUS';
import { DeliveryInfoUS } from './pages/us/DeliveryInfo';
import { BookNowUS } from './pages/us/BookNowUS';
export function App() {
  return <CountryProvider data-id="element-0" data-mp="3dl4n5uey3vz1">
      <ModalProvider data-id="element-1" data-mp="3dlns8ajhypvn">
        <Router data-id="element-2" data-mp="3dm5vvs8ho6dl">
          <ScrollToTop data-id="element-3" data-mp="3dii6n5a2u64o" />
          <GlobalModals data-id="element-4" data-mp="nw2ci75e7srm" />
          <PageTransition data-id="element-5" data-mp="nur762waucye">
        <Routes data-id="element-6" data-mp="nvaszup2llhp">
          {/* Canadian Routes */}
          <Route path="/" element={<Home data-id="element-8" data-mp="stc7e2bjwwmu" />} data-id="element-7" data-mp="su427axbqqc2" />
          <Route path="/home-care" element={<HomeCare data-id="element-10" data-mp="3685nh1tcguh" />} data-id="element-9" data-mp="sssskuh76od1" />
          <Route path="/companion-care" element={<CompanionCare data-id="element-12" data-mp="34nd1wz277z9" />} data-id="element-11" data-mp="35ovimiemwr0" />
          <Route path="/post-hospital-respite" element={<PostHospitalRespite data-id="element-14" data-mp="3ubzu8bzxzlf6" />} data-id="element-13" data-mp="3uct0zcywiaxb" />
          <Route path="/childcare" element={<Childcare data-id="element-16" data-mp="d57fh2ybeij2" />} data-id="element-15" data-mp="3uf5hrmsxaf8s" />
          <Route path="/equipment-rentals" element={<EquipmentRentals data-id="element-18" data-mp="d2bhxfqdpvv5" />} data-id="element-17" data-mp="d3cw3t2oyyh3" />
          <Route path="/facilities-staffing" element={<Facilities data-id="element-20" data-mp="86cld4uwd7jn" />} data-id="element-19" data-mp="85bb32lpgp2z" />
          <Route path="/careers" element={<Careers data-id="element-22" data-mp="3gklce8hrtq9p" />} data-id="element-21" data-mp="3gle90gn0mze4" />
          <Route path="/book-now" element={<BookNow data-id="element-24" data-mp="3gj1qa19fol00" />} data-id="element-23" data-mp="3glwbvw46obv0" />
          
          {/* US Routes */}
          <Route path="/us/nannies" element={<NanniesUS data-id="element-26" data-mp="3bkgs07dqsbe7" />} data-id="element-25" data-mp="3bnuv5hu8comp" />
          <Route path="/us/travel-nurses" element={<TravelNursesUS data-id="element-28" data-mp="3qcqy50hfjbgg" />} data-id="element-27" data-mp="3qbppt3rst32f" />
          <Route path="/us/equipment-rentals" element={<EquipmentRentalsUS data-id="element-30" data-mp="3ljg27ue5of3b" />} data-id="element-29" data-mp="3qd0oip6dzkmo" />
          <Route path="/us/delivery-info" element={<DeliveryInfoUS data-id="element-32" data-mp="2xudatutpz7vm" />} data-id="element-31" data-mp="3lieeapc1jy46" />
          <Route path="/us/book-now" element={<BookNowUS data-id="element-34" data-mp="2xsk2mb3gkfli" />} data-id="element-33" data-mp="2xtlpdctu6qj2" />

          {/* Shared Routes */}
          <Route path="/why-us" element={<WhyUs data-id="element-36" data-mp="2stpmxi0sf75m" />} data-id="element-35" data-mp="2sv0p5del46um" />
          <Route path="/blog" element={<Blog data-id="element-38" data-mp="18dhphx9ewo2u" />} data-id="element-37" data-mp="18drjrx1hphec" />
          <Route path="/faq" element={<FAQ data-id="element-40" data-mp="18bojmk6mi7vw" />} data-id="element-39" data-mp="18czpcpjmpppn" />
          <Route path="/contact" element={<Contact data-id="element-42" data-mp="1d5jbwc0anv6l" />} data-id="element-41" data-mp="1d4hqpepkdsb5" />
          <Route path="/search" element={<SearchResults data-id="element-44" data-mp="1d6aywyftskl9" />} data-id="element-43" data-mp="1d62hquco6t49" />
          <Route path="/trust-and-safety" element={<TrustAndSafety data-id="element-46" data-mp="yheqv1drr7kn" />} data-id="element-45" data-mp="yg3kquwupnqd" />
          <Route path="/corporate-care" element={<CorporateCare data-id="element-48" data-mp="13fq1hebw1m3x" />} data-id="element-47" data-mp="13eocs71y913q" />
          <Route path="/pet-care" element={<PetCare data-id="element-50" data-mp="1r4971m3jzksb" />} data-id="element-49" data-mp="13ey2dtj3168w" />
          <Route path="/housekeeping" element={<Housekeeping data-id="element-52" data-mp="1r5276480bc1h" />} data-id="element-51" data-mp="1r3zg9waop9lk" />
          <Route path="/check-ins" element={<CheckIns data-id="element-54" data-mp="1w3lwmelt75yl" />} data-id="element-53" data-mp="1w3c2qfxn8enm" />
          <Route path="/pricing" element={<Pricing data-id="element-56" data-mp="1w0zmc77jacco" />} data-id="element-55" data-mp="1w2tyox4qow55" />
          <Route path="/login" element={<Login data-id="element-58" data-mp="1i2sxfgkkbmp5" />} data-id="element-57" data-mp="1i440tfa3isfq" />
          <Route path="/post-job" element={<PostJob data-id="element-60" data-mp="1m5617zfr1aja" />} data-id="element-59" data-mp="1i3b4774upjbb" />
        </Routes>
        </PageTransition>
      </Router>
      </ModalProvider>
    </CountryProvider>;
}